/**
 * Created by MinhQuan on 9/3/2015.
 */

angular.module('taric.quota.search', ['taric.model.quota', 'taric.model.menu', 'common.template.geoarea.popup', 'common.filter.decimalNumber', 'common.helper'])
    .controller('SearchTaricQuotaController', function (CONSTANTS, TaricQuotaSearchModel, GeographicalAreaModel, $rootScope, $scope, $state, $stateParams, $uibModal, $filter, CommonHelper, $translate, $timeout, $location, countries) {
        
        var searchTaricQuotaCtrl = this;

        searchTaricQuotaCtrl.init = function (){
            searchTaricQuotaCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            searchTaricQuotaCtrl.searchCriteria = TaricQuotaSearchModel.getSearchCriteria();
            searchTaricQuotaCtrl.searchQuotaResult = TaricQuotaSearchModel.searchQuotaResult();
            searchTaricQuotaCtrl.dateFormat = CONSTANTS.dateFormat;
            searchTaricQuotaCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
            searchTaricQuotaCtrl.controlCountry = {};
            searchTaricQuotaCtrl.statuses = [
                "QUOTA_BLOCKING_EVENT",
                "QUOTA_EXHAUSTION_EVENT",
                "QUOTA_OPENED_EVENT",
                "QUOTA_REOPENING_EVENT",
                "QUOTA_SUSPENSION_EVENT",
                "QUOTA_UNBLOCKING_EVENT",
                "QUOTA_UNSUSPENSION_EVENT"
            ];
            searchTaricQuotaCtrl.loadQuotaStatuses();

            if (searchTaricQuotaCtrl.searchCriteria.status &&
                searchTaricQuotaCtrl.statuses.indexOf(searchTaricQuotaCtrl.searchCriteria.status) < 0) {
                searchTaricQuotaCtrl.searchCriteria.status = null;
            }

            if (searchTaricQuotaCtrl.isExternalLink() && searchTaricQuotaCtrl.validateExternalParameters()) {
                if (countries){

                    // get valid CountryCode
                    searchTaricQuotaCtrl.searchCriteria.country = CommonHelper.getValidSelectedItem(
                        countries.items,
                        searchTaricQuotaCtrl.searchCriteria.country,
                        null);
                }

                // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
                searchTaricQuotaCtrl.loadDataFromServerWithoutValidation(1);
            }
        };

        searchTaricQuotaCtrl.search = function () {
            //Load data for the first page
            searchTaricQuotaCtrl.loadDataFromServer(1);
        };

        //Check whether the search form is valid or not
        searchTaricQuotaCtrl.validateSearchForm = function() {
            searchTaricQuotaCtrl.resetError();
            return searchTaricQuotaCtrl.validateMandatoryFields() && searchTaricQuotaCtrl.validateOrderNumber() && searchTaricQuotaCtrl.validateCountryCode() && searchTaricQuotaCtrl.validateSimulationDate();
        };

        searchTaricQuotaCtrl.validateMandatoryFields = function(){
            if (!searchTaricQuotaCtrl.searchCriteria.simulationDate && !searchTaricQuotaCtrl.searchCriteria.orderNumber){
                searchTaricQuotaCtrl.errorCode = 'i8n.qqry.tqa.qryTariffQuotaSearchBean.dataRequired';
            }
            return searchTaricQuotaCtrl.errorCode === null;
        };

        searchTaricQuotaCtrl.validateOrderNumber = function(){
            searchTaricQuotaCtrl.errorCode = CommonHelper.validateStringByPattern(
                searchTaricQuotaCtrl.searchCriteria.orderNumber,
                "^[0-9]{6}$",
                "qqry.tqa.notDigits");
            return searchTaricQuotaCtrl.errorCode === null;
        };

        searchTaricQuotaCtrl.validateCountryCode = function(){
            searchTaricQuotaCtrl.errorCode = searchTaricQuotaCtrl.controlCountry.validate();
            return searchTaricQuotaCtrl.errorCode === null;
        };

        searchTaricQuotaCtrl.validateSimulationDate = function () {
            if (!CONSTANTS.dateRestrictionEnabled) {
                searchTaricQuotaCtrl.errorCode = CommonHelper.validateSimulationDate(searchTaricQuotaCtrl.searchCriteria.simulationDate);
                if(searchTaricQuotaCtrl.errorCode) {
                    searchTaricQuotaCtrl.errorParams = {param0: CONSTANTS.pastDate};
                }
            }
            return searchTaricQuotaCtrl.errorCode === null;
        };

        // export pdf
        searchTaricQuotaCtrl.print = function(options){
        	
            if (!searchTaricQuotaCtrl.validateSearchForm()){
                $scope.$apply();
                return;
            }

          	$rootScope.$broadcast('startSpinningPrint');
            TaricQuotaSearchModel.searchTariffQuotas().then(function(searchQuotaResult) {
            	
            	searchTaricQuotaCtrl.searchQuotaAllResult = searchQuotaResult;
            	setTimeout(function(){

                    // load documents
                    var doc = [];
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                    CommonHelper.printPlainDocument({
                        contents: doc,
                        logo: options.logo,
                        validDate: $filter('date')(searchTaricQuotaCtrl.searchCriteria.simulationDate, CONSTANTS.dateFormat),
                        title: $filter('translate')('i8n.qqry.tqa.report.report.title')
                    }, 'l').then(() => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    }, (error) => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    });

                }, 1000);
            }, function(error){
                
            	// show errors here
              	$rootScope.$broadcast('stopSpinningPrint');
                searchTaricQuotaCtrl.handleError(error);
            });
        };

        //Load data for a given page
        searchTaricQuotaCtrl.loadDataFromServer = function(page){
            if (!searchTaricQuotaCtrl.validateSearchForm()){
                return;
            }

            searchTaricQuotaCtrl.loadDataFromServerWithoutValidation(page);
        };

        //Load data for a given page without validation
        searchTaricQuotaCtrl.loadDataFromServerWithoutValidation = function(page){
            // Reset search result before searching
            searchTaricQuotaCtrl.resetSearchResult();
            searchTaricQuotaCtrl.searching = true;
            TaricQuotaSearchModel.searchTariffQuotas(page).then(function(searchQuotaResult) {
                searchTaricQuotaCtrl.searchQuotaResult = searchQuotaResult;
                searchTaricQuotaCtrl.searching = false;

                searchTaricQuotaCtrl.searchQuotaResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(searchTaricQuotaCtrl.searchCriteria.simulationDate);
                if (searchTaricQuotaCtrl.searchQuotaResult.infoCode &&
                    "i8n.common.pastDate" === searchTaricQuotaCtrl.searchQuotaResult.infoCode) {
                    searchTaricQuotaCtrl.searchQuotaResult.infoParams = CONSTANTS.pastDate;
                }

                searchTaricQuotaCtrl.updateBrowserURL();
            }, function(error){
                searchTaricQuotaCtrl.errorCode = error.data.code;
                searchTaricQuotaCtrl.errorParams = error.data.params;
                searchTaricQuotaCtrl.searching = false;
            });
        };

        /**
         * Search for tariff quotas
         * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/quota/search?sd={SimulationDate}&on={OrderNumber}&co={CountryOfOrigin}&qs={QuotaStatus}&c={Critical}&l={Language}
         *
         * Example:
         * http://localhost:8080/arctictariff-public-web/#!/taric/quota/search?sd=2015-01-01&on=090023&co=US&qs=QUOTA_EXHAUSTION_EVENT&c=true&l=en
         */
        searchTaricQuotaCtrl.updateBrowserURL = function(){
            if (!CONSTANTS.enableBookmark){
                return;
            }

            // Do not keep parameter 'frm' because there is no return to caller page
            $location.search({
                sd: CommonHelper.getBookmarkDateString(searchTaricQuotaCtrl.searchCriteria.simulationDate),
                on: searchTaricQuotaCtrl.searchCriteria.orderNumber,
                co: searchTaricQuotaCtrl.searchCriteria.country,
                qs: searchTaricQuotaCtrl.searchCriteria.status,
                c : searchTaricQuotaCtrl.searchCriteria.critical.toString(),
                l : $translate.use()
            }).replace();
        };

        searchTaricQuotaCtrl.resetSearchResult = function() {
            searchTaricQuotaCtrl.searchQuotaResult = null;
            TaricQuotaSearchModel.resetSearchResult();
        };

        //Handle page change for the quota search result table
        searchTaricQuotaCtrl.searchQuotaResultPageChanged = function (page) {
            searchTaricQuotaCtrl.loadDataFromServer(page);
        };

        searchTaricQuotaCtrl.openDatePicker = function ($event) {
            searchTaricQuotaCtrl.isDatePickerOpen = true;
        };

        searchTaricQuotaCtrl.onDateChange = function (dateString) {
            searchTaricQuotaCtrl.resetError();
            searchTaricQuotaCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(searchTaricQuotaCtrl.searchCriteria.simulationDate, dateString);
            searchTaricQuotaCtrl.loadingReferenceData = true;
            searchTaricQuotaCtrl.controlCountry.reload(searchTaricQuotaCtrl.searchCriteria.simulationDate).then(() => {
                searchTaricQuotaCtrl.loadingReferenceData = false;
            }, function (error) {
                searchTaricQuotaCtrl.errorCode = error.data.code;
                searchTaricQuotaCtrl.errorParams = error.data.params;
                searchTaricQuotaCtrl.loadingReferenceData = false;
            });
        };

        //View quota detail
        searchTaricQuotaCtrl.viewQuota = function (quotaDef){
            TaricQuotaSearchModel.setSelectedQuota(quotaDef);
            $state.go('taric.quota.view');
        };

        searchTaricQuotaCtrl.isExternalLink = function(){
            // Verify 'frm' parameter to avoid auto-search after viewing quota detail.
            return (!$stateParams.frm || $stateParams.frm !== 'taric.quota.view') && ($stateParams.sd || $stateParams.on);
        };

        // Check whether the external parameters are valid or not
        searchTaricQuotaCtrl.validateExternalParameters = function(){
            searchTaricQuotaCtrl.resetError();
            return searchTaricQuotaCtrl.validateMandatoryFields() && searchTaricQuotaCtrl.validateOrderNumber() && searchTaricQuotaCtrl.validateSimulationDate();
        };

        searchTaricQuotaCtrl.loadQuotaStatuses = function(){
            searchTaricQuotaCtrl.statusData = [];
            searchTaricQuotaCtrl.statuses.forEach(function(status){
                $translate("i8n.common.label." + status).then(function (statusDescription){
                    searchTaricQuotaCtrl.statusData.push({
                        "code": status,
                        "description": statusDescription
                    });
                });
            });

            $timeout(function(){

                //Wait for the translation is done and then do a sort
                searchTaricQuotaCtrl.statusData.sort(function (status1, status2) {
                    return status1.description.localeCompare(status2.description,  CommonHelper.getLanguageCode($translate.use()));
                });
            }, 500);
        };

        $rootScope.$on('$translateChangeSuccess', function () {
            searchTaricQuotaCtrl.loadQuotaStatuses();

            //This is just a workaround to force the page to re-render the pagination items with translated texts
            searchTaricQuotaCtrl.itemsPerPage = 99999999;
            $timeout(function(){
                searchTaricQuotaCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            }, 100);
        });

        searchTaricQuotaCtrl.openOriginPopup = function (size, origin){
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/geo-area/geoarea-popup.tmpl.html',
                controller: 'GeographicalAreaPopupController as geoAreaPopupCtrl',
                size: size,
                resolve: {
                    geoAreaMemberships: function () {
                        return GeographicalAreaModel.queryMembershipByGroupId(origin, searchTaricQuotaCtrl.searchCriteria.simulationDate);
                    },
                    origin: function () {
                        return origin;
                    }
                }
            });
        };

        searchTaricQuotaCtrl.resetError = function(){
            searchTaricQuotaCtrl.handleError(null);
        };

        searchTaricQuotaCtrl.handleError = function(error){
            if(!error){
                searchTaricQuotaCtrl.errorCode = null;
                searchTaricQuotaCtrl.errorParams = null;
            } else {
                searchTaricQuotaCtrl.errorCode = error.errorCode;
                searchTaricQuotaCtrl.errorParams = error.errorParams;
            }
        };

        searchTaricQuotaCtrl.onCountryChange = function(country){
            searchTaricQuotaCtrl.searchCriteria.country = country;
        };

    	$scope.$on('printDocument', function(event, data) {
    		
    		CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, searchTaricQuotaCtrl.print, true);
        });
    });



// WEBPACK FOOTER //
// ./app/taric/quota/search/quota-search.js